import { createApi } from '@reduxjs/toolkit/dist/query/react';
import B2ChatClient, { apiResource, b2chatBaseQuery } from '@src/client';
import { appConfig } from '@src/config/appConfig';
import { B2ChatLogoDesktop } from '@src/resources';
import { preferencesSelect } from '@src/selectors/preferences';
import { useSelector } from 'react-redux';

export type PartnersCustomUiConfig = {
  primaryColor: string;
  secondaryColor: string;
  logoUrl: string;
  webSiteUrl: string;
};

const partnerCustomUiApi = createApi({
  reducerPath: 'customUiApi',
  baseQuery: b2chatBaseQuery,
  tagTypes: ['custom-ui'],
  endpoints: builder => ({
    getCustomUiConfig: builder.query<PartnersCustomUiConfig, void>({
      providesTags: ['custom-ui'],
      keepUnusedDataFor: Infinity,
      extraOptions: { maxRetries: 0 },
      query: () =>
        apiResource(
          B2ChatClient.resources.partnersCustomUi.actions.getConfig,
          {}
        ),

      transformResponse(response: PartnersCustomUiConfig) {
        appConfig.setData('partnerCustomUi', response);
        return response;
      },
      transformErrorResponse(response) {
        appConfig.removeData('partnerCustomUi');
        return response;
      },
    }),
  }),
});

export default partnerCustomUiApi;

export const { useGetCustomUiConfigQuery, endpoints } = partnerCustomUiApi;

export const usePartnerCustomUiConfig = () =>
  useSelector(endpoints.getCustomUiConfig.select()).data;

export const useB2ChatLogo = () => {
  const preferences = useSelector(preferencesSelect);
  const partnersCustomUi =
    usePartnerCustomUiConfig() || appConfig.getData('partnerCustomUi');

  const uiConfig = preferences.uiConfigurationProperties;
  const customLogoUrl = partnersCustomUi?.logoUrl || uiConfig?.desktopLightLogo;

  return {
    logoUrl: customLogoUrl || B2ChatLogoDesktop,
    isDefault: !customLogoUrl,
  };
};
